import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ez-begin-enrollment',
  imports: [
    DatePipe,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './begin-enrollment.component.html',
  styleUrls: ['./begin-enrollment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BeginEnrollmentComponent implements OnInit {
  canSkip = false;
  enrollmentRequiredBy: Date | null = null;

  readonly #elementRef = inject(ElementRef);

  ngOnInit(): void {
    const getAttribute = this.#elementRef.nativeElement.getAttribute.bind(this.#elementRef.nativeElement);

    this.canSkip = getAttribute('can-skip') === 'can-skip';
    this.enrollmentRequiredBy = new Date(getAttribute('enrollment-required-by'));
  }
}
